import { helpers, required } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";

export default {
  employeeLoan: {
    required: helpers.withMessage(validationJson.required, required),
  },
};
